// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_N9e","cls2":"PaywallPage-cls2_3F6 PaywallPage-cls1_N9e"};